const clientsReducerDefaultState = {
  clients: [],
  searchedClients: [],
  searchedClientCompanies: [],
  addClientDialogOpen: false,
  editClient: {},
  editClientCompany: {},
  addClientCompanyDialogOpen: false,
  clientModal: {},
  deleteClientDialogOpen: false,
  deleteClientCompanyDialogOpen: false,
  companiesList: [],
  companyClients: [],
  createdClientCompany: null,
}

export default (state = clientsReducerDefaultState, action) => {
  switch (action.type) {
    case "USER::SET::CLIENT_MODAL":
      return {
        ...state,
        clientModal: action.payload,
      }
    case "CLIENT::SET_CLIENTS":
      return {
        ...state,
        clients: action.data,
      }

    case "CLIENT::SEARCH_CLIENTS":
      return {
        ...state,
        searchedClients: action.data,
      }
    case "CLIENT::SEARCH_CLIENT_COMPANIES":
      return {
        ...state,
        searchedClientCompanies: action.data,
      }
    case "CLIENT::SET":
      return {
        ...state,
        editClient: action.data,
      }
    case "CLIENT::SET_COMPANY":
      return {
        ...state,
        editClientCompany: action.data,
      }

    case "CLIENT::TOGGLE_ADD_CLIENT_DIALOG":
      return {
        ...state,
        addClientDialogOpen: action.addClientDialogOpen,
        editClient:
          action.editClient === undefined
            ? state.editClient
            : action.editClient,
      }
    case "CLIENT::TOGGLE_DELETE_CLIENT_DIALOG":
      return {
        ...state,
        deleteClientDialogOpen: action.deleteClientDialogOpen,
      }

    case "CLIENT::TOGGLE_DELETE_CLIENT_COMPANY_DIALOG":
      return {
        ...state,
        deleteClientCompanyDialogOpen: action.deleteClientCompanyDialogOpen,
      }
    case "CLIENT::SET_CLIENT_COMPANIES":
      return {
        ...state,
        companiesList: action.data,
      }

    case "CLIENT::SET_COMPANY_CLIENTS":
      return {
        ...state,
        companyClients: action.data,
      }

    case "CLIENT::TOGGLE_ADD_CLIENT_COMPANY_DIALOG":
      return {
        ...state,
        addClientCompanyDialogOpen: action.addClientCompanyDialogOpen,
        editClientCompany:
          action.editClientCompany === undefined
            ? state.editClientCompany
            : action.editClientCompany,
      }

    case "CLIENT::SET_CREATED_CLIENT_COMPANY":
      return {
        ...state,
        createdClientCompany: {
          id: action.createdClientCompany["id"],
          name: `${action.createdClientCompany["name"]}`,
        },
      }

    default:
      return state
  }
}
